export default __webpack_public_path__ + "static/comingSoon-17b36f65856db3315989f575f9d3439a.jpg";